export type FundOpportunitySector =
  | 'RESIDENTIAL_LAND'
  | 'RESIDENTIAL_BUILT_FORM'
  | 'INDUSTRIAL'
  | 'OFFICE'
  | 'RETAIL'
  | 'ALTERNATIVE_OTHER';

export const ALL_SECTOR_OPTIONS: Array<{ value: FundOpportunitySector; label: string }> = [
  { value: 'RESIDENTIAL_LAND', label: 'Residential Land' },
  { value: 'RESIDENTIAL_BUILT_FORM', label: 'Residential Built-Form' },
  { value: 'INDUSTRIAL', label: 'Industrial' },
  { value: 'OFFICE', label: 'Office' },
  { value: 'RETAIL', label: 'Retail' },
  { value: 'ALTERNATIVE_OTHER', label: 'Alternative / Other' },
];

export const SECTOR_LABELS: Readonly<Record<FundOpportunitySector, string>> = Object.freeze(
  Object.fromEntries(ALL_SECTOR_OPTIONS.map(({ value, label }) => [value, label])) as Record<
    FundOpportunitySector,
    string
  >,
);
